import React from 'react';
import BlogArticlePreview from './blog-article-preview/blog-article-preview';
import BlogTopArticles from './blog-top-articles/blog-top-articles';
import ResponsiveResolutionImage from '@components/responsive-resolution-image/responsive-resolution-image';
import {
  IArticleData,
  IArticlesData,
  ISettingsData,
  ITopArticlesData,
} from "@vitl-services/interfaces/blog";

import * as styles from './blog-articles.module.scss';

interface IProps {
  settingsData: ISettingsData;
  articlesData: IArticlesData;
  topArticlesData: ITopArticlesData;
}

const BlogArticles: React.FC<IProps> = ({
  settingsData,
  articlesData,
  topArticlesData,
}) => {
  const { post_read_more_label, blog_advert_link } = settingsData;
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.contentPosts}>
          <div className={styles.columnHeading}>
            <h2>Latest articles</h2>
          </div>
          {articlesData?.map((article: IArticleData, index: number) => {
            const { id, name, date_published, preview, author, image, slug } =
              article;

            return (
              <BlogArticlePreview
                key={id}
                title={name}
                preview={preview || ''}
                heroImage={image}
                datePublished={date_published}
                readMoreLabel={post_read_more_label}
                path={`/article/${slug}`}
                isEven={false}
                author={author?.name}
                isFirst={index === 0}
              />
            );
          })}
        </div>

        <div className={styles.contentSidebar}>
          <div className={styles.columnHeading}>
            <h2>Top articles</h2>
            {topArticlesData?.map(({ id, blog_articles_id: article }) => {
              const { name, image, date_published, slug, author } =
                article || {};
              const articleAuthor = author?.name || '';

              return (
                <BlogTopArticles
                  key={id}
                  title={name}
                  image={image?.filename_disk}
                  datePublished={date_published}
                  path={`/article/${slug}`}
                  author={articleAuthor}
                />
              );
            })}
            <a
              href={`${process.env.GATSBY_VITL_HOST_NAME}${blog_advert_link}`}
              data-testid="consultation-banner"
            >
              <div className={styles.advert}>
                <ResponsiveResolutionImage
                  url={`https://p-media.dev.vitl.com/744b5e6a-fd54-4c15-a08d-5bbcfa081e6d.jpeg`}
                  title="Advert"
                  width={337}
                  height={443}
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogArticles;
